import { useCallback, useEffect, useState } from 'react';
/** Hook returning helpers to remove or update a rich text block
 *
 * To update or remove a block from a block itself, it is necessary to do it asynchronously,
 * to avoid the state to be overridden by the call of `setEditorState` triggered by the Editor
 * component through its `onChange` property.
 *
 * Therefore, this hook was develop to listen to requests to update or remove blocks,
 * store these requests (block key and data if necessary) and act asynchronously with `useEffect`.
 *
 * @param removeBlockHelper function to remove a block
 * @param updateBlockDataHelper function to update a block
 * @returns { removeBlock, updateBlockData } functions to remove or update a block asynchronously
 */

var useBlockHelpers = function useBlockHelpers(removeBlockHelper, updateBlockDataHelper) {
  var _useState = useState(null),
      blockKeyToRemove = _useState[0],
      setBlockKeyToRemove = _useState[1];

  var _useState2 = useState(null),
      blockDataToUpdate = _useState2[0],
      setBlockDataToUpdate = _useState2[1];

  useEffect(function () {
    if (blockKeyToRemove !== null) {
      removeBlockHelper(blockKeyToRemove);
    }

    return function () {
      return setBlockKeyToRemove(null);
    };
  }, [blockKeyToRemove, removeBlockHelper]);
  useEffect(function () {
    if (blockDataToUpdate !== null) {
      updateBlockDataHelper(blockDataToUpdate.blockKey, blockDataToUpdate.data);
    }

    return function () {
      return setBlockDataToUpdate(null);
    };
  }, [blockDataToUpdate, updateBlockDataHelper]);
  var removeBlock = useCallback(function (blockKey) {
    setBlockKeyToRemove(blockKey);
  }, []);
  var updateBlockData = useCallback(function (blockKey, data) {
    setBlockDataToUpdate({
      blockKey: blockKey,
      data: data
    });
  }, []);
  return {
    removeBlock: removeBlock,
    updateBlockData: updateBlockData
  };
};

export default useBlockHelpers;